export default __webpack_public_path__ + "static/const-nine-61ebc780e7dea5683b291bb324b000f4.png";